query GetApprovalCommonData {
  companyBusinessUnits {
    nodes {
      id
      name
    }
  }
  availableApprovalDepartments(orderBy: NAME_ASC) {
    nodes {
      id
      name
    }
  }
  approvalIconTypes(orderBy: ICON_STATUS_TYPE_ASC) {
    nodes {
      id
      iconStatusType
    }
  }
  verifyApprovalMaintenancePermission
}
